<div class="container-fluid" [dir]="dir">
  <div class="row m-row">
    <div class="col-lg-6 p-3 slider-container">
      <div class="right-panel">
        <div class="right-panel-head p-3">
          <div class="dropdown">
            <button
              class="btn btn-default dropdown-toggle lang-dropdown"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ currentLanguage === 'ar' ? 'العربية' : 'English' }}
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item" (click)="changeLanguage('en-US')"
                >English</a
              >
              <a class="dropdown-item" (click)="changeLanguage('ar')"
                >العربية</a
              >
            </div>
          </div>
        </div>
        <app-splash-screen-sliders
          [isWhiteBackground]="false"
        ></app-splash-screen-sliders>
      </div>
    </div>
    <div class="col-lg-6 main-content">
      <div class="main-header">
        <div class="d-flex justify-content-between">
          @if (contactInfo) {
            <div class="contact-div mt-3 pt-2" [dir]="dir">
              <button mat-stroked-button [matMenuTriggerFor]="userMenu">
                <mat-icon
                  fontSet="material-icons-outlined"
                  class="text-secondary"
                  >help</mat-icon
                >
                <span translate class="text-secondary">Contact Us</span>
              </button>
              <mat-menu #userMenu="matMenu">
                <a
                  mat-menu-item
                  href="tel:{{ contactInfo.supportNumber | numberTranslate }}"
                  class="text-left"
                  dir="ltr"
                  translate
                >
                  <mat-icon>phone</mat-icon>
                  <span dir="ltr">{{
                    contactInfo.supportNumber | numberTranslate
                  }}</span>
                </a>
                <a
                  mat-menu-item
                  href="mailto:{{ contactInfo.supportEmail }}"
                  class="text-left"
                  dir="ltr"
                  translate
                >
                  <mat-icon>email</mat-icon>
                  {{ contactInfo.supportEmail }}
                </a>
              </mat-menu>
            </div>
          }
          <div class="language-div mt-3 pt-2">
            <app-language-selector [icon]="true"></app-language-selector>
          </div>
        </div>
      </div>
      <div class="form-div">
        <div class="">
          <div class="text-center">
            <img
              class="logo-img"
              [src]="'assets/flyplus/app-logo.svg' | assets"
              alt=""
            />
          </div>
          @if (step == 1) {
            <div class="mt-5 text-center">
              <h5 class="fw-700" translate>Recover Password</h5>
              <p class="sub-label" translate>recover_password_instruction</p>
            </div>
            <form
              [formGroup]="emailForm"
              class="d-flex flex-column"
              appTrackForm
            >
              <mat-label translate>Email or Phone Number</mat-label>
              <mat-form-field
                [hideRequiredMarker]="true"
                appearance="outline"
                class="w-100"
                subscriptSizing="dynamic"
              >
                <input
                  dir="ltr"
                  type="text"
                  matInput
                  formControlName="identifier"
                  autocomplete="username"
                  [placeholder]="'Email or phone number' | translate"
                  (blur)="trimIdentifier()"
                  required
                />
                <mat-hint
                  ><span translate>Hint:</span>
                  <span>{{
                    'username_hint'
                      | translate
                        : {
                            email: 'user@example.com',
                            phone: phoneHint | numberTranslate,
                          }
                  }}</span>
                </mat-hint>
                <mat-error>
                  @if (emailForm.controls.identifier.hasError('required')) {
                    <span translate>Email or phone number is required</span>
                  } @else {
                    <span translate>invalid_email_or_phone</span>
                  }
                </mat-error>
              </mat-form-field>
              <button
                class="align-self-stretch mt-3"
                [color]="'primary'"
                mat-flat-button
                [disabled]="
                  loading.sending || emailForm.controls.identifier.invalid
                "
                (click)="sendVerifyCode()"
                appTrackClick="forgot-password-send-verification-code-btn"
                ctaType="primary"
              >
                <span translate>Send Verification Code</span>
                <app-loader
                  class="d-inline-flex"
                  [isLoading]="loading.sending"
                ></app-loader>
              </button>
            </form>
            <div class="text-center fs-13 fw-400 my-3">
              <span translate>Remembered your password?</span>
              <a href="/login" translate>Login</a>
            </div>
          }

          @if (step == 2) {
            <div class="mt-5 text-center">
              <h5 class="fw-700" translate>Recover Password</h5>
              <p class="sub-label" translate>recover_password_code_sent</p>
            </div>
            <form
              [formGroup]="verificationCodeForm"
              class="d-flex flex-column"
              appTrackForm
            >
              <ng-otp-input
                class="text-center"
                [formCtrl]="verificationCodeForm?.controls?.code"
                [config]="otpConfig"
                dir="ltr"
              ></ng-otp-input>
              <div class="forgot-password my-3 text-secondary">
                <div translate>Didn't receive the OTP yet?</div>
                @if (isTimerActive) {
                  <span class="fw-600">
                    <span translate> Resend OTP in </span>
                    {{ getTimerText(timer) | numberTranslate }}</span
                  >
                }
                @if (!isTimerActive && !loading.sending) {
                  <a
                    class="resend-otp-link c-pointer"
                    (click)="sendVerifyCode()"
                    translate
                    >Resend OTP?</a
                  >
                }
              </div>
              <button
                class="align-self-stretch"
                [color]="'primary'"
                mat-flat-button
                [disabled]="
                  loading.verifying ||
                  verificationCodeForm.controls.code.invalid
                "
                (click)="verifyCode()"
                translate
                appTrackClick="forgot-password-verify-code-btn"
                ctaType="primary"
              >
                <span translate>Verify Code</span>
                <app-loader
                  class="d-inline-flex"
                  [isLoading]="loading.verifying"
                ></app-loader>
              </button>
              <button
                class="align-self-stretch mt-2 go-back-btn"
                mat-stroked-button
                (click)="goBack()"
              >
                <span translate>Go Back</span>
              </button>
            </form>
          }

          @if (step == 3) {
            <div class="mt-5 text-center">
              <h5 class="fw-700" translate>Reset Password</h5>
              <p class="sub-label" translate>
                Please enter your updated password
              </p>
            </div>
            <form
              [formGroup]="newPasswordForm"
              class="d-flex flex-column"
              appTrackForm
            >
              <mat-label translate>Password</mat-label>
              <mat-form-field
                [hideRequiredMarker]="true"
                appearance="outline"
                class="w-100"
                subscriptSizing="dynamic"
              >
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  matInput
                  formControlName="newPassword"
                  [placeholder]="'password' | translate"
                  required
                />
                <mat-icon
                  class="c-pointer"
                  (click)="showHidePassword()"
                  matSuffix
                  >{{
                    !showPassword ? 'visibility_off' : 'visibility'
                  }}</mat-icon
                >
                <mat-error>
                  @if (
                    newPasswordForm.controls.newPassword?.hasError('required')
                  ) {
                    <span translate>Password is required</span>
                  }
                  @for (rule of passwordRules; track rule.key) {
                    @if (
                      newPasswordForm.controls.newPassword?.hasError(rule.key)
                    ) {
                      <span>{{ rule.label | translate }}</span
                      ><br />
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-label translate>Confirm Password</mat-label>
              <mat-form-field
                [hideRequiredMarker]="true"
                appearance="outline"
                class="w-100 confirm-password-field"
                subscriptSizing="dynamic"
              >
                <input
                  matInput
                  [type]="showConfirmPassword ? 'text' : 'password'"
                  formControlName="confirmPassword"
                  [placeholder]="'Confirm Password' | translate"
                  required
                />
                <mat-icon
                  class="c-pointer"
                  (click)="showHideConfirmPassword()"
                  matSuffix
                >
                  {{ !showConfirmPassword ? 'visibility_off' : 'visibility' }}
                </mat-icon>
                <!-- 1) Required error for confirmPassword control -->
                <mat-error
                  *ngIf="
                    newPasswordForm.controls.confirmPassword.hasError(
                      'required'
                    )
                  "
                >
                  <span translate>Confirm password is required</span>
                </mat-error>
                <!-- 2) Group‐level mismatch error -->
                <mat-error
                  *ngIf="
                    newPasswordForm.controls.confirmPassword.hasError(
                      'mismatch'
                    )
                  "
                >
                  <span translate>Passwords do not match</span>
                </mat-error>
              </mat-form-field>
              <button
                class="align-self-stretch"
                [color]="'primary'"
                mat-flat-button
                [disabled]="
                  loading.resetting ||
                  !passwordResetToken ||
                  newPasswordForm.controls.newPassword.invalid ||
                  newPasswordForm.controls.confirmPassword.hasError(
                    'mismatch'
                  ) ||
                  newPasswordForm.controls.confirmPassword.hasError('required')
                "
                (click)="resetPassword()"
                translate
                appTrackClick="forgot-password-reset-password-btn"
                ctaType="primary"
              >
                <span translate>Reset Password</span>
                <app-loader
                  class="d-inline-flex"
                  [isLoading]="loading.resetting"
                ></app-loader>
              </button>
            </form>
          }
          <div class="mt-5 text-center">
            <img
              [src]="'assets/flyplus/powered-by.png' | assets"
              width="130"
              class="mt-5 mb-3"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
